export default __webpack_public_path__ + "static/media/cat.1d2a0e33.svg";